import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const WspolnotaRozliczenieButtons = props => {

  const { miesiac, setMiesiac, listaMsc, handleShowPrint } = props;

  const select = listaMsc?.map( (e,i) => (
    <option key={i} value={e}>
      {e} 
    </option>
  ));

  const onChangeHandle = (e) => setMiesiac(e.target.value);
    
  return (
    <div className="buttons"> 
      <select onChange={onChangeHandle} value={miesiac}>
        <option value="0">
          Wybierz okres:
        </option>
        {select}
      </select>
      <FontAwesomeIcon 
        icon={faPrint} 
        className='pointer'
        onClick={handleShowPrint}
        style={{margin: "0 50px"}}
      />
    </div>
  )
}

export default WspolnotaRozliczenieButtons;